// Simple function that gets a zip number and returnes its location
// as a string
// For example if we get zip === 101 we return 'Miðbær'
export const mapZipToDetailLocation = (zip) => {
  switch (zip) {
    case 101:
      return 'Miðbær';
    case 103:
      return 'Kringlan / Hvassaleiti';
    case 104:
      return 'Vogar';
    case 105:
      return 'Austurbær';
    case 107:
      return 'Vesturbær';
    case 108:
      return 'Austurbær';
    case 109:
      return 'Neðra Breiðholt';
    case 110:
      return 'Árbær';
    case 111:
      return 'Efra Breiðholt';
    case 112:
      return 'Grafarvogur';
    case 113:
      return 'Grafarholt';
    case 116:
      return 'Kjalarnes';
    case 170:
      return 'Seltjarnarnes';
    case 190:
      return 'Vogar';
    case 200:
    case 201:
    case 202:
    case 203:
      return 'Kópavogur';
    case 210:
    case 212:
      return 'Garðabær';
    case 220:
    case 221:
    case 222:
      return 'Hafnarfjörður';
    case 225:
      return 'Álftanes';
    case 230:
    case 232:
    case 233:
    case 235:
    case 260:
      return 'Reykjanesbær';
    case 240:
      return 'Grindavík';
    case 245:
      return 'Sandgerði';
    case 250:
      return 'Garður';
    case 270:
    case 271:
    case 276:
      return 'Mosfellsbær';
    case 300:
    case 301:
    case 302:
      return 'Akranes';
    case 310:
    case 311:
      return 'Borgarnes';
    case 320:
      return 'Reykholt';
    case 340:
      return 'Stykkishólmur';
    case 345:
      return 'Flatey';
    case 350:
      return 'Grundarfjörður';
    case 355:
      return 'Ólafsvík';
    case 356:
      return 'Snæfellsbær';
    case 360:
      return 'Hellissandur';
    case 370:
    case 371:
      return 'Búðardalur';
    case 380:
      return 'Reykhólahreppur';
    case 400:
    case 401:
      return 'Ísafjörður';
    case 410:
      return 'Hnífsdalur';
    case 415:
      return 'Bolungarvík';
    case 420:
      return 'Súðavík';
    case 425:
      return 'Flateyri';
    case 430:
      return 'Suðureyri';
    case 450:
    case 451:
      return 'Patreksfjörður';
    case 460:
      return 'Tálknafjörður';
    case 465:
      return 'Bíldudalur';
    case 470:
    case 471:
      return 'Þingeyri';
    case 500:
      return 'Staður';
    case 510:
    case 512:
      return 'Hólmavík';
    case 522:
      return 'Kjörvogur';
    case 523:
      return 'Bær';
    case 520:
      return 'Drangsnes';
    case 524:
      return 'Árneshreppur';
    case 530:
    case 531:
      return 'Hvammstangi';
    case 540:
    case 541:
      return 'Blönduós';
    case 545:
      return 'Skagaströnd';
    case 550:
    case 551:
      return 'Sauðárkrókur';
    case 560:
      return 'Varmahlíð';
    case 565:
    case 566:
      return 'Hofsós';
    case 570:
      return 'Fljót';
    case 580:
      return 'Siglufjörður';
    case 600:
    case 601:
    case 602:
    case 603:
      return 'Akureyri';
    case 610:
      return 'Grenivík';
    case 611:
      return 'Grímsey';
    case 620:
    case 621:
      return 'Dalvík';
    case 625:
      return 'Ólafsfjörður';
    case 630:
      return 'Hrísey';
    case 640:
    case 641:
      return 'Húsavík';
    case 645:
      return 'Fosshóll';
    case 650:
      return 'Laugar';
    case 660:
      return 'Mývatn';
    case 670:
    case 671:
      return 'Kópasker';
    case 675:
      return 'Raufarhöfn';
    case 680:
    case 681:
      return 'Þórshöfn';
    case 685:
      return 'Bakkafjörður';
    case 690:
      return 'Vopnafjörður';
    case 700:
    case 701:
      return 'Egilsstaðir';
    case 710:
      return 'Seyðisfjörður';
    case 715:
      return 'Mjóifjörður';
    case 720:
      return 'Borgarfjörður eystri';
    case 730:
      return 'Reyðarfjörður';
    case 735:
      return 'Eskifjörður';
    case 740:
      return 'Neskaupstaður';
    case 750:
      return 'Fáskrúðsfjörður';
    case 755:
      return 'Stöðvarfjörður';
    case 760:
      return 'Breiðdalsvík';
    case 765:
      return 'Djúpivogur';
    case 780:
    case 781:
      return 'Höfn';
    case 785:
      return 'Öræfi';
    case 800:
    case 801:
    case 802:
      return 'Selfoss';
    case 810:
      return 'Hveragerði';
    case 815:
      return 'Þorlákshöfn';
    case 816:
      return 'Ölfus';
    case 820:
      return 'Eyrarbakki';
    case 825:
      return 'Stokkseyri';
    case 840:
      return 'Laugarvatn';
    case 845:
      return 'Flúðir';
    case 850:
    case 851:
      return 'Hella';
    case 860:
    case 861:
      return 'Hvolsvöllur';
    case 870:
    case 871:
      return 'Vík';
    case 880:
      return 'Kirkjubæjarklaustur';
    case 900:
    case 902:
      return 'Vestmannaeyjar';
    default:
      return '';
  }
};

// Simple function that gets a location and returnes an array of zips that belong
// to that location
// For example if we get location === 'Reykjavík' we return [101, 103, 104, ..., 116]
export const mapLocationToZips = (location) => {
  switch (location) {
    case 'Höfuðborgarsvæðið':
    case 'capital':
      return [
        101, 103, 104, 105, 107, 108, 109, 110, 111, 112, 113, 116,
        200, 201, 202, 203,
        210, 212, 225,
        220, 221, 222,
        270, 271, 276,
        170,
      ];
    case 'Reykjavík':
    case 'reykjavik':
      return [
        101, 103, 104, 105, 107, 108, 109, 110, 111, 112, 113, 116,
      ];
    case 'Kópavogur':
    case 'kopavogur':
      return [
        200, 201, 202, 203,
      ];
    case 'Garðabær':
    case 'gardabaer':
      return [
        210, 212, 225,
      ];
    case 'Hafnarfjörður':
    case 'hfj':
      return [
        220, 221, 222,
      ];
    case 'Mosfellsbær':
    case 'moso':
      return [
        270, 271, 276,
      ];
    case 'Seltjarnarnes':
    case 'seltjarnanes':
      return [
        170,
      ];
    case 'Suðurnes':
    case 'sudurnes':
      return [
        190, 230, 232, 233, 235, 260, 240, 245, 250,
      ];
    case 'Norðurland':
    case 'nordurland':
      return [
        500, 510, 512, 520, 522, 523, 524, 530, 531, 540, 541, 545, 550, 551, 560, 565, 566, 570,
        580, 600, 601, 602, 603, 610, 611, 620, 621, 625, 630, 640, 641, 645, 650, 660, 670, 671,
        675, 680, 681,
      ];
    case 'Vestfirðir':
    case 'vestfirdir':
      return [
        380, 400, 401, 410, 415, 420, 425, 430, 450, 451, 460, 465, 470, 471,
      ];
    case 'Vesturland':
    case 'vesturland':
      return [
        300, 301, 302, 310, 311, 320, 340, 345, 350, 355, 356, 360, 370, 371,
      ];
    case 'Austurland':
    case 'austurland':
      return [
        685, 690, 700, 701, 710, 715, 720, 730, 735, 740, 750, 755, 760, 765, 780, 781, 785,
      ];
    case 'Suðurland':
    case 'sudurland':
      return [
        800, 801, 802, 810, 815, 816, 820, 825, 840, 845, 850, 851, 860, 861, 870, 871, 880,
        900, 902,
      ];
    default:
      return [];
  }
};

// Simple function that gets a location as a string and returnes its representation
// uglified
// For example if we get location ==== 'Reykjavík' we return 'reykjavik'
export const uglifyLocation = (location) => {
  switch (location) {
    case 'Höfuðborgarsvæðið':
      return 'capital';
    case 'Reykjavík':
      return 'reykjavik';
    case 'Kópavogur':
      return 'kopavogur';
    case 'Garðabær':
      return 'gardabaer';
    case 'Hafnarfjörður':
      return 'hfj';
    case 'Mosfellsbær':
      return 'moso';
    case 'Seltjarnarnes':
      return 'seltjarnanes';
    case 'Suðurnes':
      return 'sudurnes';
    case 'Norðurland':
      return 'nordurland';
    case 'Vestfirðir':
      return 'vestfirdir';
    case 'Vesturland':
      return 'vesturland';
    case 'Austurland':
      return 'austurland';
    case 'Suðurland':
      return 'sudurland';
    default:
      return '';
  }
};

// Simple function that gets a location as a string and returnes its representation
// prettified
// For example if we get location ==== 'reykjavik' we return 'Reykjavík'
export const prettifyLocation = (location) => {
  switch (location) {
    case 'capital':
      return 'Höfuðborgarsvæðið';
    case 'reykjavik':
      return 'Reykjavík';
    case 'kopavogur':
      return 'Kópavogur';
    case 'gardabaer':
      return 'Garðabær';
    case 'hfj':
      return 'Hafnarfjörður';
    case 'moso':
      return 'Mosfellsbær';
    case 'seltjarnanes':
      return 'Seltjarnarnes';
    case 'sudurnes':
      return 'Suðurnes';
    case 'nordurland':
      return 'Norðurland';
    case 'vestfirdir':
      return 'Vestfirðir';
    case 'vesturland':
      return 'Vesturland';
    case 'austurland':
      return 'Austurland';
    case 'sudurland':
      return 'Suðurland';
    default:
      return '';
  }
};

// Simple function that gets a type and returnes its display value
// For example if we get type === 'house' we return 'Hús'
export const mapType = (type) => {
  switch (type) {
    case 'house':
      return 'Hús';
    case 'apartment':
      return 'Íbúð';
    case 'room':
      return 'Herbergi';
    case 'commercial':
      return 'Atvinnuhúsnæði';
    default:
      return '';
  }
};

// Simple function that gets a number and returnes it as a string with dot as a
// thousand seperator
export const getThousandSeperatedNumber = number => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');



// WEBPACK FOOTER //
// ./src/common/app/helperFunctions.js